import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    Button, List, Typography, useMediaQuery, IconButton,
    Box, styled
} from '@mui/material';
import { documentsActions, fileActions, addDataCaptureIdentification, addTitleLegoCurrent } from '../../store/actions'
import { GenericStatusElement, GenericButtonList, CustomAlertMaterial, CustomLoadingOverlay, GenericContainer, CustomUploadCamera, FullCameraCapture, GeoLocationGeneric } from '../../components'
import { HelpDialog } from './HelpDialog'
import { ClearSession, blobToBase64 } from '../../utils'
//import { mainStyles } from '../../styles/Main.js'
import { useStyles } from './IdentityValidationStyles'
import { coreFunctions, getNameDocINE } from '../../utils';
import { useTranslation } from 'react-i18next';


export default function IdentityValidationComponent(props) {
    const location = useLocation()
    const gridContainer = {} //mainStyles.gridStyle()
    const localStyles = useStyles()
    const navigate = useNavigate()

    const [loadView, setLoadView] = useState(false)
    const [openHelps, setOpenHelps] = useState(false)
    const [showHelp, setShowHelp] = useState(false)
    const [ocrErrorAlert, setOcrErrorAlert] = useState(false)
    const [sectionsCurrent, setSectionsCurrent] = useState([])
    const [listDocTypes, setListDocTypes] = useState([])
    const [folioId, setFolioId] = useState(0)
    const [sectionId, setSectionId] = useState(0)
    const [nameStage, setNameStage] = useState('')
    const [docNameCurrent, setDocNameCurrent] = useState('') //for the metadata 
    const [sectionName, setSectionName] = useState('') //for the metadata 
    const [captureType, setCaptureType] = useState('')
    const [document, setDocument] = useState(null)
    const [latitude, setLatitude] = useState("-85.05112878")
    const [longitude, setLongitude] = useState("-180")
    const [activeGeolocation, setActiveGeolocation] = useState(false)
    const [activeOCRFileInfo, setActiveOCRFileInfo] = useState(false)
    const [typeOcrCaptureCurrent, setTypeOcrCaptureCurrent] = useState("Online")
    const [activeFacialVerification, setActiveFacialVerification] = useState(false)
    const [docId, setDocId] = useState(null)
    const [docType_Id, setDocType_Id] = useState(null)
    const [context, setContexData] = useState({ sequences: 0, selectedCapture: 'photo' })

    const [initCamera, setInitCamera] = useState(false)
    const [uploadingFile, setUploadingFile] = useState(false)
    const [activeCaptureDoc, setActiveCaptureDoc] = useState(false)
    const valIdentityData = useSelector(state => state.ValIdentityData)
    // console.log('valIdentityData', valIdentityData)
    const { t } = useTranslation();

    const actorId = location.state.actorId

    const identificationCaptureState = useSelector(state => state.IndentificationCaptureData)
    const file = useSelector(state => state.FileInfo)
    // const ocrResponse = useSelector(state => state.OcrData)
    const cargaDocWithSecResponse = useSelector(state => state.CargaDocWithSecData)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(addTitleLegoCurrent("addTitleLegoCurrent"))
        setContexData({ sequences: 0, selectedCapture: 'photo' })
        console.log("location.state: ***********: ", location)
        setFolioId(location.state.folioId)
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        // setDocNameCurrent(location.state.docName)
        // console.log("location.state: ***********: ", location.state)
    }, [])

    useEffect(() => {
        console.log("identificationCaptureState .state: ***********: ", identificationCaptureState)
        if (identificationCaptureState?.CaptureData != undefined && identificationCaptureState?.CaptureData != null
            && identificationCaptureState?.CaptureData?.length != 0) {
            setContexData(identificationCaptureState.CaptureData)
        }
    }, [identificationCaptureState])

    useEffect(() => {
        console.log("..........sectionsCurrent:.......... ", sectionsCurrent, docNameCurrent)
        if (sectionsCurrent != undefined && sectionsCurrent != null
            && sectionsCurrent?.length <= 2 && uploadingFile && context.sequences > 0) {
            let requestOcr = {
                File_id: folioId,
                DocumentType_Id: docType_Id,
                TransactionId: localStorage.getItem('TransactionId')
            }
            console.log("requestOcr......**********1***: ", requestOcr)
            dispatch(documentsActions.GetOcrData(requestOcr))
            setActiveOCRFileInfo(true)
            dispatch(fileActions.GetFileInfo(folioId))
        }
        else if (context.sequences > 0 && context.sequences < 2 && uploadingFile) {
            console.log("requestOcr......**********2***: ")
            followCaptureProcess()
        }
        else if (context.sequences > 0 && context.sequences >= 2 && uploadingFile) {
            let requestOcr = {
                File_id: folioId,
                DocumentType_Id: docType_Id,
                TransactionId: localStorage.getItem('TransactionId')
            }
            console.log("requestOcr......**********3***: ", requestOcr)
            dispatch(documentsActions.GetOcrData(requestOcr))
            setActiveOCRFileInfo(true)
            dispatch(fileActions.GetFileInfo(folioId))
        }
    }, [context.sequences, uploadingFile])

    useEffect(() => {
        /* console.log("Document returned*********: ", document)
        console.log("context.selectedCapture returned*********: ", context)
        console.log("context.selectedCapture returned*********: ", context.selectedCapture) */
        if (document != undefined && document != null
            && document != '' && context.selectedCapture === 'photo') {
            setInitCamera(false)
            askforTransactionId()
        }
        // else if (document != '' && context.selectedCapture === 'pdf') {
        // }
    }, [document])

    useEffect(() => {
        // setLoadView(file.loading)
        if (file.items != undefined && file.items?.Stage != null) {
            console.log("-- FILE INFO DE INE VERIFICAR PARAMETRO------", file.items)
            // console.log("-- FILE INFO DE INE VERIFICAR PARAMETRO---FILE---", file)
            if (docNameCurrent === undefined || docNameCurrent === null || docNameCurrent == ""
                || docNameCurrent?.length === undefined || docNameCurrent?.length == 0) {
                console.log("location.state.docName 11!!*****: file.itemNameDoc?.Name", location.state.docName, file.itemNameDoc?.Name)
                let nameDoc = file.itemNameDoc?.Name === undefined || file.itemNameDoc?.Name === null ||
                    file.itemNameDoc?.Name?.length == 0 ? location.state.docName : file.itemNameDoc?.Name
                // console.log("DocName", nameDoc)
                // setDocNameCurrent(nameDoc)
            }
            let docName = docNameCurrent
            if (activeOCRFileInfo === true) {
                // console.log('MUESTRA LOS DATOS', file)
                // console.log('valIdentityData DENTRO', valIdentityData)
                // if (valIdentityData.items?.Result?.IdentityValidationResult?.EvaluationIsFaceCorrect === false) {
                //     setErrorValidacionPorcentaje(true);
                //     console.log('EMNTRO AQUI')
                //     console.log('NO PASO')
                // } else {
                // console.log('SI PASO');
                setActiveOCRFileInfo(false)
                let nextStage = file.items.Stage
                let stageName = nextStage.Name
                let stageId = nextStage.Id
                let folioId = file.items.Id
                let stage = file.items
                let metadatos = file.items.Metadatos
                let docIds = file.itemsSections.Sections

                console.log("activeOCRFileInfo----file.items.Stage.DocumentalCategory?.DocumentalGroups*******: ", file.items.Stage.DocumentalCategory?.DocumentalGroups)
                let DocumentData = getNameDocINE(null, file.items.Stage)
                let sections = sectionsCurrent.length <= 0 ? DocumentData?.Sections : sectionsCurrent
                console.log(".????????????..........DocumentData?.Sections----??????: ", DocumentData?.Sections)
                console.log("activeOCRFileInfo----: ", activeOCRFileInfo, "sections-----------:", sections)
                if (file.itemsValidation != null && file.itemsValidation?.ActiveFacialVerification == "0") {
                    const nextComponent = 'Carousel'
                    coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, docName, metadatos, docIds } })
                }
                else {
                    const typeProcessSelfie = 2
                    const nextComponent = 'LifeTestComponent'
                    coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, docName, metadatos, docIds, sections, typeProcessSelfie } })

                    // const nextComponent = 'HelpSelfie'
                    // // console.log("activeOCRFileInfo----selfie redirect: ", nextComponent, sections, folioId, docName, metadatos)
                    // coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, docName, metadatos, docIds, sections } })
                }

            } else {
                dispatch(addTitleLegoCurrent(file.items.Stage.Name))
                // setNameStage(file.items.Stage.Name)
                setFolioId(file.items.Id)
                if (coreFunctions.GetRedirectStep(file, navigate)) {
                    console.log('La clave selfiePruebaVida existe en el localStorage.');

                } else if (file.items.Stage.DocumentalCategory != undefined && file.items.Stage.DocumentalCategory != null) {
                    console.log("-----!!!!!!!Entro a reincio de stage-!!!!!-------------------")
                    dispatch(addDataCaptureIdentification({ sequences: 0, selectedCapture: 'photo' }));
                    const itemsToList = file.items.Stage.DocumentalCategory.DocumentalGroups.map((itemPrin) =>
                        itemPrin.DocumentTypes.map((item) => {
                            console.log('item', item)
                            return {
                                Id: item.Id,
                                Name: item.Name,
                                Required: item.Required,
                                Description: item.Description,
                                Sections: item.Sections,
                                ShowInSummary: item.ShowInSummary,
                                Properties: item.Properties,
                                IdDocCurrent: item.Document === null ? null : item.Document?.Id,
                            }
                        })
                    )
                    const combinedData = [].concat(...itemsToList);
                    setListDocTypes(combinedData)
                }
            }
        }
        if (file.error != undefined) {
            // alert(file.error)
            // console.log("file.error----: ", file.error)
        }

    }, [file]);

    useEffect(() => {
        if (listDocTypes.length === 1) {
            captureProcess(listDocTypes[0].Sections, listDocTypes[0].Name, listDocTypes[0].Properties, listDocTypes[0].IdDocCurrent, listDocTypes[0].Id)
        }
    }, [listDocTypes])

    useEffect(() => {
        // console.log("Validate: sectionName, docNameCurrent, capture: ", sectionName, docNameCurrent, captureType)
        if (sectionName != "" && docNameCurrent != ""
            && sectionName?.length > 0 && docNameCurrent?.length > 0 && activeCaptureDoc) {
            // && captureType != "" && captureType?.length > 0) {
            // console.log("context.sequences****** : ", context.sequences)
            // if (context.sequences === 1) {
            //     setShowHelp(true)
            //     setOpenHelps(true)
            //     setExecuteParam(true)
            //     // buttonClick.
            //     // console.log("Ejecutar button")
            //     // buttonExecuteClick.current.click()
            //     // handleContinueCapture();
            // } else {
            setOpenHelps(true)
            if (navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/Android/i)) {
                setShowHelp(true)
            } else {
                setShowHelp(false)
                handleContinueCapture()
            }
            // handleContinueCapture()
            // buttonClick.current.onclick = function (event) {
            //     console.log("Pseudo Cancel button clicked.");
            // // }
            // }
            // console.log("Active Open Help: sectionName, docNameCurrent, capture: ", sectionName, docNameCurrent, captureType)
        } else {
            // console.log("Validate: sectionName, docNameCurrent, capture: ", sectionName, docNameCurrent, captureType)
        }
    }, [sectionName, docNameCurrent, captureType, activeCaptureDoc])

    useEffect(() => {
        // console.log("cargaDocWithSecResponse: ", cargaDocWithSecResponse)
        if (cargaDocWithSecResponse.items?.TransactionId != null && uploadingFile) {
            setLoadView(false)
            // console.log('context', context.sequences);
            // console.log(cargaDocWithSecResponse.items);
            // si es el igual a cero y que sea INE
            // liena 132
            localStorage.setItem('TransactionId', cargaDocWithSecResponse?.items?.TransactionId)//Almacenar TransactionId
            if (context.sequences == 0 && (sectionsCurrent != undefined && sectionsCurrent != null
                && sectionsCurrent?.length > 2)) {
                console.log('ENTRO EN ESTA 1')
                console.log("cargaDocWithSecResponse.items.DocumentLivenessResponseData: ", cargaDocWithSecResponse.items.DocumentLivenessResponseData)
                if (cargaDocWithSecResponse.items.DocumentLivenessResponseData != undefined && cargaDocWithSecResponse.items.DocumentLivenessResponseData != null) {
                    localStorage.setItem('validateINEFront', JSON.stringify(cargaDocWithSecResponse.items.DocumentLivenessResponseData))//Almacenar TransactionId
                }
                dispatch(addDataCaptureIdentification({ sequences: (context.sequences + 1), selectedCapture: 'photo' }));
                // context.setSequences(context.sequences + 1)
            } else {
                // console.log('ENTRO EN ESTA 2')
                // context.setSequences(context.sequences + 1)
                dispatch(addDataCaptureIdentification({ sequences: (context.sequences + 1), selectedCapture: 'photo' }));
            }
        } else if (cargaDocWithSecResponse.error != undefined && uploadingFile) {
            setLoadView(false)
            setUploadingFile(false)
            alert(cargaDocWithSecResponse.error)
            clearCancelAction()
        }
    }, [cargaDocWithSecResponse])

    let clearCancelAction = () => {
        dispatch(addDataCaptureIdentification({ sequences: 0, selectedCapture: 'photo' }));
        // context.setSequences(0)
        setActiveCaptureDoc(false)
        setDocument(null)
        setSectionId(null)
        setSectionName(null)
        setCaptureType(null)
    }

    const askforTransactionId = () => {
        setLoadView(true)
        let requestUpload = {
            UploadSectionRequestData: {
                B64Content: null,
                FileId: folioId,
                Actor_Id: actorId,
                SkipActor: 0,
                SectionId: sectionId,
                Extension: null,
                Skip: false,
                SkipReason: null,
                Metadata: null,
                ContinueWorkFlow: false,
                Geolocation: {
                    Latitude: latitude,
                    Longitude: longitude,
                },
                DeferLoad: false,
                OmitirMergeVideo: null,
                OmitirRemovebg: null,
                AsignarEstatusCarga: null
            },
            File_id: folioId,
            Carga: {
                Referencia: folioId.toString(),
                TransactionId: localStorage.getItem('TransactionId') == "" || localStorage.getItem('TransactionId') == "null" ? null : localStorage.getItem('TransactionId'),
                EsBolqueFin: (sectionsCurrent != undefined && sectionsCurrent != null
                    && sectionsCurrent?.length <= 2) ? true :
                    (context.sequences == 0 && context.sequences < 2)
                        || (context.sequences > 0 && context.sequences >= 2) ? false : true,
                TipoDocumento: docNameCurrent,
                Seccion: sectionName,
                Imagenes: [
                    {
                        B64: document,
                        Extension: ".jpg",
                    }
                ],
                Metadatos: null
            }
        }
        console.log("CargaDocumentoWithSection-------: Request: ", requestUpload)
        setUploadingFile(true)
        dispatch(documentsActions.CargaDocumentoWithSection(requestUpload))
    }

    const captureProcess = (Sections, DocName, Properties, docIdCurrent, documentType_Id) => {
        console.log("Sections-------Capture process-------: Name: ", DocName,
            " - docIdCurrent: ", docIdCurrent,
            "Sections: ", Sections, " documentType_Id: ", documentType_Id)
        console.log("context.sequences", context.sequences)

        let currentIndex = ((sectionsCurrent != undefined && sectionsCurrent != null
            && sectionsCurrent?.length > 2) ? context.sequences : 0)
        console.log("..........currentIndex..................: ", context.sequences)
        setSectionsCurrent(Sections)
        setSectionId(Sections[currentIndex]?.Id)
        setSectionName(Sections[currentIndex]?.Name)
        setDocNameCurrent(DocName)
        setDocId(docIdCurrent)
        setCaptureType(Sections[currentIndex]?.CaptureType)
        setDocType_Id(documentType_Id)

        let typeOcrCaptureVal = Properties?.find(element => element.Name == "TypeOcrCapture")
        if (typeOcrCaptureVal?.Value != undefined && typeOcrCaptureVal?.Value != null && typeOcrCaptureVal?.Value != "") {
            setTypeOcrCaptureCurrent(typeOcrCaptureVal?.Value)
        }

        let activeFacialVerification = Properties?.find(element => element.Name == "ActiveFacialVerification")
        setActiveFacialVerification(activeFacialVerification?.Value === undefined || activeFacialVerification?.Value === null ? false : activeFacialVerification?.Value)
        let ActiveGeolocationVal = Properties?.find(element => element.Name == "ActiveGeolocation")
        setActiveGeolocation(ActiveGeolocationVal?.Value === undefined || ActiveGeolocationVal?.Value === null ? false : ActiveGeolocationVal?.Value)
    }

    const followCaptureProcess = () => {
        setSectionId(sectionsCurrent[context.sequences].Id)
        setSectionName(sectionsCurrent[context.sequences].Name)
        setCaptureType(sectionsCurrent[context.sequences].CaptureType)
    }

    const goToCameraMicroblink = () => {
        let documetId = docId
        let sections = sectionsCurrent
        let docName = docNameCurrent?.length === undefined || docNameCurrent?.length == 0 ? file.itemNameDoc?.Name : docNameCurrent
        const nextComponent = 'MicroblinkCamera'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, sectionId, sections, docName, sectionName, activeFacialVerification, documetId, activeGeolocation } })
    }

    const handleContinueCapture = event => {
        console.log("event****************: ", event)
        if (context.sequences == 0) {
            console.log("context.sequences == 0****************: ", context.sequences)
            dispatch(addDataCaptureIdentification({
                sequences: context.sequences,
                selectedCapture: 'photo',
            }));
        }
        if (typeOcrCaptureCurrent == "Microblink") {
            goToCameraMicroblink()
        }
        else if (typeOcrCaptureCurrent == "Online") {
            // console.log("init foto---- handleContinueCapture()--------------------Entro")
            setOpenHelps(false)
            setInitCamera(true)
        }
    }

    // console.log('listDocTypes', listDocTypes)
    return (<GenericContainer>
        {activeGeolocation &&
            <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
                console.log("succes,latitude, longitude ", latitude, longitude);
                setLatitude(latitude);
                setLongitude(longitude);
            }}
                ErrorFN={(error) => console.log('error', error)}
            />
        }
        <Typography variant="subtitle1" >
          {t("identity_type")}
        </Typography>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            {listDocTypes.map((i, index) => {
                return (
                    <GenericButtonList
                        key={`btn_key_${i.Id}`}
                        id={`btn_id_${i.Id}`}
                        onClick={() => {
                            console.log("click event select ", i)
                            setActiveCaptureDoc(true)
                            captureProcess(i.Sections, i.Name, i.Properties, i.IdDocCurrent, i.Id)
                        }} >
                        <GenericStatusElement
                            key={`key_${i.Id}`}
                            keyProps={i.Id}
                            text={i.Required ? `${i.Name}*` : i.Name}
                            description={i.Description} />
                    </GenericButtonList>
                )
            })}
        </Box>

        {loadView && <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />}
        {initCamera ?
            navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/Android/i) ?
                <CustomUploadCamera onCapture={blob => {
                    // console.log("camera return blob: ", blob)
                    blobToBase64(blob).then(res => {
                        // console.log("blobToBase64-------- Carga WEB----------", res)
                        let resultReplace = res.replace('data:image/jpeg;base64,', '')
                        setDocument(resultReplace)
                        setInitCamera(false)
                    });
                }} />
                :
                <FullCameraCapture open={initCamera}
                    onClose={() => {
                        setInitCamera(false)
                        clearCancelAction()
                    }}
                    onSendData={(data) => {
                        console.log("Data full camera: ", data)
                        setDocument(data)
                    }}
                    sectionName={sectionName}
                    DocName={docNameCurrent}
                    capture={captureType}
                />
            : null
        }

        <CustomAlertMaterial //I haven't test this one yet 
            title='Volver a capturar'
            body='La extracción de datos no se pudo realizar, intenta volver a capturar la foto.'
            closeAction={() => setOcrErrorAlert(false)}
            open={ocrErrorAlert}
            leftButtonText='Salir'
            leftButtonAction={() => {
                // sessionStorage.clear()
                ClearSession()
                navigate("/auth/")
            }}
            rightButtonText='Volver a capturar'
            rightButtonAction={() => {
                window.location.reload()
            }}
        />

        {showHelp === true ?
            <HelpDialog
                open={openHelps}
                closeAction={() => {
                    setOpenHelps(false)
                    setShowHelp(false)
                    clearCancelAction()
                }}
                sectionName={sectionName}
                DocName={docNameCurrent}
                capture={captureType}
                onCapture={handleContinueCapture}
            />
            : null}
    </GenericContainer>)
}